/**
 * @generated SignedSource<<a04b652d20fbf480a72e9f4a5672761e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer$data = {
  readonly hasAccessToCopilot: boolean;
  readonly " $fragmentType": "StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer";
};
export type StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer$key = {
  readonly " $data"?: StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAccessToCopilot",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "cad803348629393b7875097c2552b240";

export default node;
